import styled from '@emotion/styled';

export const UploadPreviewContainer = styled.div`
	box-sizing: border-box;
	width: 200px;
	height: 280px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	gap: 8px;
`;

export const FilePreview = styled.div`
	box-sizing: border-box;
	border: 1px solid #b1b1b1;
	border-radius: 4px;
	width: 200px;
	height: 256px;
	position: relative;
	padding: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const PreviewLoading = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	justify-content: center;
	> div {
		height: auto;
	}
`;

export const StyledFileThumbnail = styled.img`
	display: block;
	max-width: 100%;
	min-height: 100%;
`;

export const StyledCrossButton = styled.div`
	position: absolute;
	top: -10px;
	right: -11px;
`;
